import { ValueType } from '../types';

export const isTriggerValueType = (valueType: ValueType): valueType is ValueType.Trigger =>
  valueType === ValueType.Trigger;
